import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ApplyPipe, ApplyPipeModule, CalendarPickerModule, KeyValueBlockModule } from "ngx-zcs-components";
import { MatIconModule } from '@angular/material/icon';

import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { HeatpumpDailyTelemetryComponent } from './heatpump-daily-telemetry.component';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxEchartsModule } from 'ngx-echarts';

@NgModule({
  declarations: [
    HeatpumpDailyTelemetryComponent,
  ],
  exports: [
    HeatpumpDailyTelemetryComponent,
  ],
  imports: [
    ApplyPipeModule,
    BlockTitleComponent,
    CalendarPickerModule,
    CommonModule,
    FormsModule,
    IonicModule,
    KeyValueBlockModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts/core') }),
    ReactiveFormsModule,
  ]
})
export class HeatpumpDailyTelemetryModule { }
